import { useMemo } from "react";
import { useTable } from "react-table";
import { formatCurrency } from "../../../../helpers";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useSelector } from "react-redux";

export const usePOItemsTable = ({ POItems = [], PODetails = null }) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
      },
      {
        Header: "Store",
        accessor: "store_id",
        Cell: ({ cell: { value } }) => storeMap[value]?.name || "N/A",
      },
      {
        Header: "Ordered QTY",
        accessor: "requested_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={`${globalStyles.statusBlock}`}
            style={{ minWidth: "40px" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Unit",
        accessor: "unit",
        Cell: ({ cell: { value } }) => value?.unit || value || "N/A",
      },

      {
        Header: "Unit Cost Price",
        accessor: "cost_price",
        Cell: ({ cell: { value }, row }) =>
          formatCurrency({
            value: value,
            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
      {
        Header: "Total Cost Price",
        Cell: ({ row }) =>
          formatCurrency({
            value:
              Number(row?.original?.cost_price) *
              Number(row?.original?.requested_quantity || 0),

            currencyCode: storeMap?.[row?.original?.store_id]?.currency_code,
          }),
      },
    ],
    [storeMap],
  );

  const instance = useTable({
    columns,
    data: POItems || [],
  });

  return {
    instance,
  };
};
